import { memo, useMemo } from "react"
import { useSelector } from "react-redux"
import { checkExpandedRowsContainRow } from "../../../../selectors/home"
import { OptionExpiryType } from "../../../../reducer/options.reducer"
import { RootState } from "../../../../store"
import { Typography } from "@mui/material"
import ThinArrowDownIcon from "../../../../assets/icons/ThinArrowDownIcon";
import ThinArrowRightIcon from "../../../../assets/icons/ThinArrowRightIcon";
import { matchPath } from "react-router-dom"
import ROUTES from "../../../../assets/routes"
import { OptionChainViewKey } from "../../../../assets/constants"
import { selectOptionChainTableView } from "../../../../selectors/common"
import { OptionChainTableView } from "../../fnoHeader/optionsChainSettingsDialog"

const getExpiryRowClassName = (rowExpanded: boolean, darkTheme: boolean): string => {
    const baseClasses = 'h-full font-feature-num align-middle font-feature-num'
    const backgroundClass = !rowExpanded 
        ? (darkTheme ? 'bg-row-open-dark' : 'bg-row-open')
        : (darkTheme ? 'bg-row-dark' : 'bg-row')
    
    return `${baseClasses} ${backgroundClass}`
}

const ExpiryRowRenderOnly = ({ RecKey, text, ivxExpiry, pcrExpiry }: { RecKey: string, text: string, ivxExpiry: number, pcrExpiry: number }) => {
    const rowExpanded = useSelector(checkExpandedRowsContainRow(RecKey, matchPath(ROUTES.simulator, window.location.pathname) ? OptionChainViewKey.HISTORICAL : OptionChainViewKey.LIVE))
    const data = useMemo(() => JSON.parse(text) as OptionExpiryType, [text])
    const darkTheme = useSelector((store: RootState) => store.commonStore.darkTheme)
    const ivx = ivxExpiry * 100 ? (ivxExpiry * 100)?.toFixed(2) : '-'
    const pcr = pcrExpiry ? pcrExpiry?.toFixed(2) : '-'
    const selectedOptionChainTableView = useSelector(selectOptionChainTableView)

    const expiryRowClassName = getExpiryRowClassName(rowExpanded, darkTheme)

    return (
        <div
            className={expiryRowClassName}
            style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'relative',
                 padding:"0px !important"
            }}
        >
            <div className="flex items-center expiry-full-row-left-sticky" style={{
                position: 'sticky',
                left: 0,
                zIndex: 5,
                paddingRight: '8px'
            }}>
                <ThinArrowDownIcon fontSize={"small"} />
                <div style={{ marginRight: '10px' }}>
                    {data.numberOfDaysToExpiry === 0 ? 'Today' : `${data.numberOfDaysToExpiry}d`}
                </div>
                {
                    selectedOptionChainTableView !== OptionChainTableView.NORMAL ?
                        <div style={{ marginRight: '10px' }}>
                            {
                                selectedOptionChainTableView === OptionChainTableView.CALLS ?
                                    'Calls' : selectedOptionChainTableView === OptionChainTableView.PUTS ?
                                        'Puts' : selectedOptionChainTableView === OptionChainTableView.ITM ?
                                            'ITM' : selectedOptionChainTableView === OptionChainTableView.OTM ?
                                                'OTM' : null
                            }
                        </div> : null
                }
                <div>{data.weeklyExpiry ?
                    <Typography variant={'caption'} className="ml-3 p-1 rounded-sm"
                        sx={{ backgroundColor: theme => theme.palette.background.paper }}>W</Typography> : null}</div>
            </div>
            <div className="expiry-full-row-right-sticky" style={{
                display: 'flex',
                alignItems: 'center',
                position: 'sticky',
                right: 0,
                zIndex: 5,
                paddingLeft: '8px'
            }}>
                <div className="flex" style={{ width: '80px', textAlign: 'left' }}><Typography
                    sx={{ color: (theme) => theme.palette.text.secondary }} fontSize={14}
                    style={{ marginRight: '5px' }}>PCR </Typography>{` ${pcr}`}</div>
                <div className="flex" style={{ width: '70px', textAlign: 'left' }}><Typography
                    sx={{ color: (theme) => theme.palette.text.secondary }} fontSize={14}
                    style={{ marginRight: '5px' }}>IVx </Typography>{` ${ivx}`}</div>
            </div>
        </div>
    )

}

export default memo(ExpiryRowRenderOnly)